.text {
  font-size: 14px;
  line-height: 20px;
  margin-top: 12px;
}

.textSecondary {
  font-size: 14px;
  line-height: 20px;
  @include themify($themes) {
    color: themed("neutral-to-primary");
  }
  margin-bottom: 12px;
}

.modal {
  width: 600px;

  .body {
    display: flex;
    flex-direction: column;
  }

  .form {
    &.overflow {
      overflow: auto;
    }
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 20px;
    gap: 15px;

    > div {
      padding: 0;
    }

    .phoneInputContainer {
      border-radius: 8px;
      @include themify($themes) {
        background-color: themed("main-secondary");
      }
    }

    .switchContainer {
      grid-column: 1 / span 2;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }

  .permissionsEditor {
    flex: 1;
    overflow: auto;
    margin: 15px 0;
  }
}
